import { Div } from "@tblabs/truffle";
import { Order } from "../../../../../Models/Order";
import { LinkToOrder } from "./LinkToOrder";


export class OrderBox extends Div
{
    constructor(order: Order)
    {
        super();

        this.Append(
            new LinkToOrder(order),
            " - ",
            order.CurrentStateForAdmin
        );

        this.Margin(6).Background("#fff").DisplayInlineBlock().BorderRadius(16).Padding(4, 12).MarginLeft(12);
    }
}
